import { ChevronLeft } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import React from "react";
import Logo from "../../../assets/images/logo_small.png";
import { StyledDrawer } from "../../styled/layout";
import ListDrawer from "./listDrawer";

function ResponsiveDrawer({ open, handleDrawerToggle }) {
  return (
    <StyledDrawer.Drawer variant="permanent" open={open}>
      <StyledDrawer.Toolbar open={open}>
        <StyledDrawer.Logo src={Logo} alt="Logo" />
        <IconButton onClick={handleDrawerToggle} size="small">
          <ChevronLeft />
        </IconButton>
      </StyledDrawer.Toolbar>
      <ListDrawer />
    </StyledDrawer.Drawer>
  );
}

export default ResponsiveDrawer;
